import Vue from 'vue'
import axios from '@/plugins/axios'

export const findAll = async (_, params = {}) => {
  try {
    const { data } = await axios.get('rcs-homologation', { params })
    return data || []
  } catch (err) {
    console.error('Erro ao buscar solicitações RCS:', err)
    return []
  }
}

export const create = async (_, body) => {
  Vue.prototype.$loading(true)

  try {
    const formData = new FormData()

    Object.entries(body).forEach(([field, value]) => {
      if (value === null || value === undefined || value === '') return

      formData.append(field, value)
    })

    // O endpoint recebe os arquivos via multipart (FileFieldsInterceptor),
    // por isso o Content-Type nao pode ser JSON.
    const { data } = await axios.post('rcs-homologation', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      silentNotify: true,
    })

    return data
  } catch (err) {
    return null
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const approve = async (_, id) => {
  Vue.prototype.$loading(true)
  try {
    await axios.put(`rcs-homologation/approve/${id}`)
    return true
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const refuse = async (_, { id, refusedReason }) => {
  Vue.prototype.$loading(true)
  try {
    await axios.put(`rcs-homologation/refuse/${id}`, { refusedReason })
    return true
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}
